document.addEventListener("DOMContentLoaded", () => {
  const HEADER_HEIGHT = 80;
  const MOBILE_BREAKPOINT = 749;
  let isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
  let swiperInstance = null;
  let currentIndex = 0;
  let destroyNavImageVisibility = () => {};

  const selectors = {
    sectionHeader: ".section-header",
    imageItem: ".product__image-item",
    navItem: ".navigation-image .item",
    prevButton: ".icon-chevron-up",
    nextButton: ".icon-chevron-down",
    navImage: ".navigation-image",
    imageWrapper: ".product__image-list-wrapper",
    swiperContainer: ".productSwiper",
  };

  const elements = {
    sectionHeader: document.querySelector(selectors.sectionHeader),
    imageItems: [...document.querySelectorAll(selectors.imageItem)],
    navigationItems: [...document.querySelectorAll(selectors.navItem)],
    prevButton: document.querySelector(selectors.prevButton),
    nextButton: document.querySelector(selectors.nextButton),
    navImage: document.querySelector(selectors.navImage),
    imageWrapper: document.querySelector(selectors.imageWrapper),
    swiperContainer: document.querySelector(selectors.swiperContainer),
  };

  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }
  window.scrollTo(0, 0);

  if (!elements.imageItems.length || !elements.navigationItems.length) return;

  function initNavImageVisibility() {
    if (!elements.navImage || !elements.imageWrapper) {
      return () => {};
    }

    let isVisible = true;
    let ticking = false;
    let rafId = null;

    elements.navImage.style.opacity = "1";
    elements.navImage.style.pointerEvents = "auto";

    const checkVisibility = () => {
      const wrapperRect = elements.imageWrapper.getBoundingClientRect();
      const navRect = elements.navImage.getBoundingClientRect();
      const shouldBeVisible = navRect.bottom <= wrapperRect.bottom;

      if (shouldBeVisible !== isVisible) {
        isVisible = shouldBeVisible;
        elements.navImage.style.opacity = isVisible ? "1" : "0";
        elements.navImage.style.pointerEvents = isVisible ? "auto" : "none";
      }

      ticking = false;
    };

    const scrollHandler = () => {
      if (!ticking) {
        ticking = true;
        rafId = window.requestAnimationFrame(checkVisibility);
      }
    };

    window.addEventListener("scroll", scrollHandler, { passive: true });
    checkVisibility();

    return () => {
      window.removeEventListener("scroll", scrollHandler);
      if (rafId) {
        window.cancelAnimationFrame(rafId);
      }
    };
  }

  const handleNavClick = (index) => {
    const previousIndex = currentIndex;
    updateNavigation(index);
    scrollToImage(index, previousIndex);
  };

  const handleDirectionClick = (direction) => {
    const previousIndex = currentIndex;
    const lastIndex = elements.imageItems.length - 1;
    const newIndex =
      direction === "prev"
        ? (currentIndex - 1 + elements.imageItems.length) %
          elements.imageItems.length
        : (currentIndex + 1) % elements.imageItems.length;

    updateNavigation(newIndex);
    scrollToImage(newIndex, previousIndex);
  };

  function updateNavigation(newIndex) {
    if (newIndex === currentIndex) return;
    elements.navigationItems[currentIndex]?.classList.remove("active");
    elements.navigationItems[newIndex]?.classList.add("active");
    currentIndex = newIndex;
  }

  function scrollToImage(index, previousIndex) {
    if (index === previousIndex) return;

    const targetImage = elements.imageItems[index];
    if (!targetImage) return;

    const isGoingDown = previousIndex > index;
    const scrollOffset =
      targetImage.getBoundingClientRect().top +
      window.scrollY -
      window.innerHeight / 2 +
      targetImage.clientHeight / 2 -
      HEADER_HEIGHT / 2;

    window.scrollTo({ top: scrollOffset, behavior: "smooth" });
  }

  const handleScroll = (() => {
    let lastCall = 0;
    const throttleTime = 100;

    return () => {
      const now = Date.now();
      if (now - lastCall >= throttleTime) {
        lastCall = now;

        const closestIndex = elements.imageItems.reduce(
          (closest, item, index) => {
            const rect = item.getBoundingClientRect();
            const distance = Math.abs(
              rect.top + rect.height / 2 - window.innerHeight / 2
            );
            return distance < closest.distance ? { index, distance } : closest;
          },
          { index: 0, distance: Infinity }
        ).index;

        updateNavigation(closestIndex);
      }
    };
  })();

  const prevClickHandler = () => handleDirectionClick("prev");
  const nextClickHandler = () => handleDirectionClick("next");

  const navClickHandlers = elements.navigationItems.map(
    (_, index) => () => handleNavClick(index)
  );

  const mobileNavClickHandlers = elements.navigationItems.map(
    (_, index) => () => {
      if (swiperInstance) {
        swiperInstance.slideToLoop(index);
      }
    }
  );

  function initMobile() {
    if (!swiperInstance && elements.swiperContainer) {
      swiperInstance = new Swiper(selectors.swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
      });

      swiperInstance.on("slideChange", () => {
        updateNavigation(swiperInstance.realIndex);
      });
    }

    elements.navigationItems.forEach((navItem, index) => {
      navItem.addEventListener("click", mobileNavClickHandlers[index]);
    });

    if (elements.prevButton) {
      elements.prevButton.addEventListener("click", () => {
        if (swiperInstance) swiperInstance.slidePrev();
      });
    }

    if (elements.nextButton) {
      elements.nextButton.addEventListener("click", () => {
        if (swiperInstance) swiperInstance.slideNext();
      });
    }
  }

  function destroyMobile() {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }

    elements.navigationItems.forEach((navItem, index) => {
      navItem.removeEventListener("click", mobileNavClickHandlers[index]);
    });

    if (elements.prevButton) {
      elements.prevButton.removeEventListener("click", () => {
        if (swiperInstance) swiperInstance.slidePrev();
      });
    }

    if (elements.nextButton) {
      elements.nextButton.removeEventListener("click", () => {
        if (swiperInstance) swiperInstance.slideNext();
      });
    }
  }

  function initDesktop() {
    elements.sectionHeader.style.top = "0";
    elements.navigationItems.forEach((navItem, index) => {
      navItem.addEventListener("click", navClickHandlers[index]);
    });

    elements.prevButton?.addEventListener("click", prevClickHandler);
    elements.nextButton?.addEventListener("click", nextClickHandler);
    window.addEventListener("scroll", handleScroll);

    destroyNavImageVisibility = initNavImageVisibility();
  }

  function destroyDesktop() {
    elements.navigationItems.forEach((navItem, index) => {
      navItem.removeEventListener("click", navClickHandlers[index]);
    });

    elements.prevButton?.removeEventListener("click", prevClickHandler);
    elements.nextButton?.removeEventListener("click", nextClickHandler);
    window.removeEventListener("scroll", handleScroll);

    destroyNavImageVisibility();
  }

  const handleResize = (() => {
    let resizeTimeout;

    return () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const newIsMobile = window.innerWidth <= MOBILE_BREAKPOINT;

        if (newIsMobile !== isMobile) {
          isMobile = newIsMobile;

          if (isMobile) {
            destroyDesktop();
            initMobile();
          } else {
            destroyMobile();
            initDesktop();
          }
        }
      }, 100); // 100ms debounce
    };
  })();

  if (isMobile) {
    initMobile();
  } else {
    initDesktop();
  }

  window.addEventListener("resize", handleResize);
});
